export const dateFormats = {
  dateFormat: "MM-DD-YYYY",
  timeFormat: "hh:mm A",
  datetimeFormat: "MM-DD-YYYY hh:mm A",
};


export const masterObjectType: any = {
  'Update Profile': [
    { key: "name", title: "First Name" },
    { key: "last_name", title: "Last Name" },
  ],
  'Change Password': [
    { key: "user_id", title: "ID" },
    { key: "email", title: "Email" },
    { key: "password", title: "Password" },
    { key: "old_password", title: "Old Password" },
    { key: "new_password", title: "New Password" },
    { key: "confirm_password", title: "Confirm Password" },
  ],
  'Change Status': [
    { key: "target_id", title: "ID" },
    { key: "status", title: "Status" },
  ],
  'Roles': [
    { key: "target_id", title: "ID" },
    { key: "name", title: "Name" },
    // { key: "privileges", title: "Privileges" },
  ],
  'Ethinicity': [
    { key: "target_id", title: "ID" },
    { key: "name", title: "Name" },
  ],
  'Military Status': [
    { key: "target_id", title: "ID" },
    { key: "name", title: "Name" },
  ],
  'Locations': [
    { key: "target_id", title: "ID" },
    { key: "name", title: "Name" },
    { key: "vr_training_location", title: "Location" },
    { key: "location", title: "Location" },
    { key: "type", title: "Type" },
    { key: "description", title: "Description" },
  ],
  'Testimonials': [
    { key: "target_id", title: "ID" },
    { key: "title", title: "Name" },
    { key: "subtitle", title: "Designation" },
    { key: "description", title: "Description" },
  ],
  'Certifications': [
    { key: "target_id", title: "ID" },
    { key: "short_form", title: "Short Form" },
    { key: "industries_name", title: "Industries" },
    { key: "added_industry", title: "Added Industries" },
    { key: "removed_industry", title: "Removed Industries" },
    { key: "acronym", title: "Long Form" },
    { key: "description", title: "Description" },
  ],
  'Careers': [
    { key: "target_id", title: "ID" },
    { key: "name", title: "Name" },
    { key: "added_industry", title: "Added Industries" },
    { key: "removed_industry", title: "Removed Industries" },
    { key: "industries_name", title: "Industries" },
    { key: "added_certification", title: "Added Certifications" },
    { key: "removed_certification", title: "Removed Certifications" },
    { key: "certifications_name", title: "Certifications" },
    { key: "added_career_category", title: "Added Career Categories" },
    { key: "removed_career_category", title: "Removed Career Categories" },
    { key: "categories_name", title: "Career Category" },
    { key: "default_flag", title: "Is Default" },
    { key: "critical", title: "Is Critical" },
    { key: "group_name", title: "Career Group" },
    { key: "level", title: "Career Level" },
    // { key: "file", title: "Image" },
    { key: "salary_start", title: "Salary Start" },
    { key: "salary_end", title: "Salary End" },
    { key: "video_url", title: "Youtube video Url" },
    { key: "description", title: "Description" },
    { key: "knowledge_skills", title: "Knowledge/Skills" },
    { key: "education_training", title: "Education Training" },
    { key: "experience", title: "Experience" },
    { key: "credentialing", title: "Credentialing Required/Optional" },
    { key: "career_path_moves_from_this_role", title: "Career Path Moves From This Role" },
    // { key: "career_category_text", title: "Career Category Description" },
  ],
  'Skill Categories': [
    { key: "target_id", title: "ID" },
    { key: "code", title: "Code" },
    { key: "name", title: "Name" },
    { key: "industry_name", title: "Industry" },
    { key: "description", title: "Description" },
  ],
  'Career Categories': [
    { key: "target_id", title: "ID" },
    { key: "code", title: "Code" },
    { key: "name", title: "Name" },
    { key: "industry_name", title: "Industry" },
    { key: "description", title: "Description" },
  ],
  'Occupational Groups': [
    { key: "target_id", title: "ID" },
    { key: "code", title: "Code" },
    { key: "name", title: "Name" },
    { key: "industry_name", title: "Industry" },
  ],
  'Education Training': [
    { key: "target_id", title: "ID" },
    { key: "name", title: "Name" },
    { key: "has_leadership", title: "Has Leadership?" },
    { key: "high_school_diploma_or_ged", title: "High School Diploma or GED" },
    { key: "associate_degree", title: "Associate Degree" },
    { key: "bachelors_degree", title: "Bachelors Degree" },
    { key: "masters_degree", title: "Masters Degree" },
    { key: "pre_apprenticeship", title: "Pre Apprenticeship" },
    { key: "apprenticeship", title: "Apprenticeship" },
    { key: "not_available", title: "Not Available" },
    { key: "doctoral_degree", title: "Doctoral Degree" },
  ],
  'Experience': [
    { key: "target_id", title: "ID" },
    { key: "experience", title: "Experience" },
    { key: "zero_experience", title: "Zero Experience" },
    { key: "level_1", title: "Level 1 Supporting Activities" },
    { key: "level_2", title: "Level 2 Executing Activities" },
    { key: "level_3", title: "Level 3 Managing Activities" },
    { key: "level_4", title: "Level 4 Planning Strategic Work" },
    { key: "level_5", title: "Level 5 Leading Strategic Work" },
  ],
  'Career Path': [
    { key: "target_id", title: "ID" },
    { key: "code", title: "Code" },
    { key: "career_level", title: "Career Level" },
    { key: "industry_name", title: "Industry Name" },
    { key: "careers", title: "Careers" },
    { key: "added_career", title: "Added Careers" },
    { key: "removed_career", title: "Removed Careers" },
    { key: "education_training", title: "Education Training" },
    { key: "education_level_name", title: "Education Level" },
    { key: "experience", title: "Experience" },
    { key: "experience_level", title: "Experience Level" },
  ],
  'Industries': [
    { key: "target_id", title: "ID" },
    { key: "industry_name", title: "Industry Name" },
    { key: "category_name", title: "Category" },
    { key: "is_show", title: "Is Visible" },
    { key: "is_available", title: "Is Active" },
    { key: "description", title: "Description" },
  ],
  'Acronyms': [
    { key: "target_id", title: "ID" },
    { key: "acronym", title: "Acronym" },
    { key: "title", title: "Title" },
    { key: "added_industry", title: "Added Industries" },
    { key: "removed_industry", title: "Removed Industries" },
    { key: "industries_name", title: "Industries" },
    { key: "description", title: "Description" },
  ],
  'Career Group': [
    { key: "target_id", title: "ID" },
    { key: "name", title: "Name" },
  ],
  'Interest Discovery': [
    { key: "target_id", title: "ID" },
    { key: "type", title: "Type" },
    { key: "question", title: "Question" },
    { key: "code", title: "Code" },
    { key: "industry_name", title: "Industry" },
    { key: "added_career_category", title: "Added Career Category" },
    { key: "removed_career_category", title: "Removed Career Category" },
    { key: "added_occupational_group", title: "Added Occupational Groups" },
    { key: "removed_occupational_group", title: "Removed Occupational Groups" },
  ],
  'Skill Portrait': [
    { key: "target_id", title: "ID" },
    { key: "question", title: "Question" },
    { key: "careers_name", title: "Careers" },
    { key: "added_career", title: "Added Careers" },
    { key: "removed_career", title: "Removed Careers" },
    { key: "occupational_group_names", title: "Occupational Groups" },
    { key: "added_occupational_group", title: "Added Occupational Groups" },
    { key: "removed_occupational_group", title: "Removed Occupational-Groups" },
    { key: "description", title: "Description" },
    { key: "answer_options", title: "Answer Option" },
    { key: "master_type", title: "Master Type" },
    { key: "industries_name", title: "Industries" },
    { key: "added_industries", title: "Added Industries" },
    { key: "removed_industries", title: "Removed Industries" },
    { key: "skill_categories_name", title: "Skill Categories" },
    { key: "added_skill_category", title: "Added Skill Categories" },
    { key: "removed_skill_category", title: "Removed Skill Categories" },
  ],
  'Customers': [
    { key: "target_id", title: "ID" },
    { key: "company_name", title: "Customer Name" },
    { key: "industry_name", title: "Industries" },
    { key: "selected_type", title: "Select Customer" },
    { key: "user_id", title: "Existing User ID" },
    { key: "name", title: "First Name" },
    { key: "last_name", title: "Last Name" },
    { key: "mobile_no", title: "Mobile Number" },
    { key: "email", title: "Email" },
    { key: "existing_user", title: "Existing User" },
  ],
  'Access Codes': [
    { key: "target_id", title: "ID" },
    { key: "campaign_name", title: "Customer Name" },
    { key: "company", title: "Customer" },
    { key: "industry_name", title: "Industry" },
    { key: "access_code_count", title: "Total Access Codes" },
    { key: "start_date", title: "Start Date" },
    { key: "end_date", title: "End Date" },
    { key: "category_name", title: "Career Categories" },
    { key: "special_flag", title: "Access Code Type" },
    { key: "short_code", title: "Subscription Unique Code" },
    { key: "access_code", title: "Custom Access Code" },
    { key: "description", title: "Description" },
  ],
  'CMS': [
    { key: "target_id", title: "ID" },
    { key: "title", title: "Title" },
    { key: "description", title: "Description" },
    { key: "meta_title", title: "Meta Title" },
    { key: "meta_keyword", title: "Meta Keyword" },
    { key: "meta_description", title: "Meta Description" },
  ],
  'Home Page': [
    { key: "compass_video_youtube_url", title: "Youtube Url" },
  ],




  /* baki home page */
  'Users Management': [
    { key: "target_id", title: "ID" },
    { key: "name", title: "First Name" },
    { key: "last_name", title: "Last Name" },
    { key: "mobile_no", title: "Mobile Number" },
    { key: "email", title: "Email" },
    { key: "role", title: "Role" },
    { key: "password", title: "Password" },
    { key: "dob", title: "Date of birth" },
    { key: "gender_name", title: "Gender" },
    { key: "race_name", title: "Ethnicity" },
    { key: "company_name", title: "Customer Name" },
    { key: "campaign_name", title: "Subscription Name" },
    { key: "access_code", title: "Access Code" },
    { key: "disabilities_name", title: "Disability Status" },
    { key: "veteran_status_name", title: "Military Status" },
    { key: "location", title: "Location (Zip Code)" },
    { key: "city", title: "City" },
    { key: "house_hold_income_name", title: "Household Income" },
    { key: "willing_to_relocate", title: "Willing to Relocate?" },
    { key: "education_level_name", title: "Education Level" },
    { key: "year_of_experience_name", title: "Years Of Experience" },
  ]
}



